import type { CustomerCreateViewModel } from "@payping/api";
import { createCustomer } from "@payping/redux/actions";
import { useMessagedAsyncFn } from "@payping/web-components";
import { FC } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import CustomerForm from "./form";
import { LocationStateSearch } from "./types";

const Create: FC = () => {
  const location = useLocation();
  const locationSearch = (location.state as LocationStateSearch)?.locationSearch;
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();

  const [{ loading }, handleCreate] = useMessagedAsyncFn(
    async (customerData: CustomerCreateViewModel): Promise<void> => {
      try {
        await dispatch(createCustomer(customerData));
      } catch {
        /* empty */
      }
    },
    [dispatch],
    undefined,
    { success: false },
  );

  return (
    <CustomerForm
      title={t("customer.add.title")}
      loading={loading}
      onOk={handleCreate}
      locationSearch={locationSearch}
    />
  );
};

export default Create;
